
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as errormwD7kY_45BU1_rHGEshIkO6bNB5B0luZiwF4k9TLpjX_45IMeta } from "/app/pages/error.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as terms1wCL_jcKgXyjae_4516VMbFrKHvZd0F4Waht3oN_MqrwYMeta } from "/app/pages/terms.vue?macro=true";
import { default as onboardYKxWzLZMaSn_gfyUJnFv7qCyby5X9HKsYDp98_456MFOkMeta } from "/app/pages/onboard.vue?macro=true";
import { default as thank_45younfXQQV_45m_nd4_hppzDzD5gaDFCMO3Gis_45vsHgFrgkSEMeta } from "/app/pages/thank-you.vue?macro=true";
import { default as unauthorized17NYwdK_vpXoMmVXmhdTSn6CG_AM5wMHLBy01ScJbgcMeta } from "/app/pages/unauthorized.vue?macro=true";
import { default as indexJtiR2iUJYsVgaMe_458fDwmvRX6y7wUgu7tvkBlbEbH60Meta } from "/app/pages/company/index.vue?macro=true";
import { default as cookie_45policyobIGMQYUw6rt9Qc9OcdKPEKq_Zy03HD556Uygv48nqwMeta } from "/app/pages/cookie-policy.vue?macro=true";
import { default as indexZ7rS3TVsHvwNMIIbHmXr9wIa0NFoxQL8IDc5_45KFersoMeta } from "/app/pages/updates/index.vue?macro=true";
import { default as privacy_45policyzgG_45S68_451GHrVnCshLKLsmg43yjC4fB7Q3UU1pkWXTMMeta } from "/app/pages/privacy-policy.vue?macro=true";
import { default as indexiAREaKKDdmALuNrWmAmlu5mGfupAFSuf3o6NVPh0rdgMeta } from "/app/pages/security/index.vue?macro=true";
import { default as _91slug_93naSb8DZ7yLdHhB_GRWgO3pdL74a8do0Mk8XUkafYRoMMeta } from "/app/pages/updates/[slug].vue?macro=true";
import { default as _91user_id_93bm2q70ec2p20et3ffIlknaIdkZLGvNqMrER2nMw93WQMeta } from "/app/pages/profile/[user_id].vue?macro=true";
import { default as extension_45sbomXzASPJLPcksAfNq8iZJQdui7cZYjg728H8zIaYjCynMMeta } from "/app/pages/security/extension-sbom.vue?macro=true";
import { default as callbackYf9eMQGRztYT2ybcJZ8WHwOUVqKf_9fH3KIA7mQ44E0Meta } from "/app/pages/integrations/email/callback.vue?macro=true";
import { default as callbackDusPmnNVdqJ_45XRDTZMbilOBUu97rkd1M_45ealfPCDiC8Meta } from "/app/pages/integrations/hubspot/callback.vue?macro=true";
import { default as indexftU2CwTklbgAtpCtZDHHzPj3QaE5Wq84XHJH3WdNkRQMeta } from "/app/pages/company/[company_public_id]/index.vue?macro=true";
import { default as settingsDqKUgek3SQeT_45Hr809ZCQq6IWsR6kSlxh83dOFJC6NIMeta } from "/app/pages/company/[company_public_id]/settings.vue?macro=true";
import { default as foundationJLT3p_yCUHcHHS_VieGJF8xRZYcJKERk9Pp9fn83OgMMeta } from "/app/pages/company/[company_public_id]/foundation.vue?macro=true";
import { default as index_bNiBJUiYXzkLRxEV6xgL9fDlJtQq3tFwpWBp_45_LT_AMeta } from "/app/pages/company/[company_public_id]/alerts/index.vue?macro=true";
import { default as integrationseFhaeKF4OcRFkc9QQSQXuOCd99t8ZTpvXW_C3PHvwcMMeta } from "/app/pages/company/[company_public_id]/integrations.vue?macro=true";
import { default as ai_45preferences7bprAYHe8FVBY7d1udyoOgfQatCAK6vcPpW4wjYliMYMeta } from "/app/pages/company/[company_public_id]/ai-preferences.vue?macro=true";
import { default as indexpHvT_8ZanczhfL8xDw0F_GF32u2mjYZeD9hX5nWDuUUMeta } from "/app/pages/company/[company_public_id]/features/index.vue?macro=true";
import { default as indexStUrarAaeOr8P0DAqs6Bbk0_45ZP4V8ochCDwAlZXhnyMMeta } from "/app/pages/company/[company_public_id]/insights/index.vue?macro=true";
import { default as index8s_veLAyEyKShcmg6IpB6lEF8alc5S7VqpZav4tjjt4Meta } from "/app/pages/company/[company_public_id]/projects/index.vue?macro=true";
import { default as backlog_45managergDNRYN7Q1PyMeYqBHy4lR4DGYSkM9CKu2SA4ryNtQFMMeta } from "/app/pages/company/[company_public_id]/backlog-manager.vue?macro=true";
import { default as indexMRrSYbPwzJnnj0uod9ZNXMXbmL7teDguCxR_45dCWs0SQMeta } from "/app/pages/company/[company_public_id]/agent-tasks/index.vue?macro=true";
import { default as indexoWuekdRHLmCaT_45ZlYj__yRquk7IaF0ZfrAUv_4509VJC4Meta } from "/app/pages/company/[company_public_id]/competitors/index.vue?macro=true";
import { default as _91task_id_935c4vvd_ddK7S5NRkBjJ8INXKH1G9IoHtmVFNFQsa9Q8Meta } from "/app/pages/company/[company_public_id]/agent-tasks/[task_id].vue?macro=true";
import { default as _91project_id_93frJzWc_450e_UqcquWof9QsMByz4l9mu6Ei3IySD4GlfAMeta } from "/app/pages/company/[company_public_id]/projects/[project_id].vue?macro=true";
import { default as _91competitor_id_93ePL7Epg1GwPDG5Eh52QmalJszGroO9eaqfoWN3PsG_IMeta } from "/app/pages/company/[company_public_id]/competitors/[competitor_id].vue?macro=true";
export default [
  {
    name: "error",
    path: "/error",
    component: () => import("/app/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "onboard",
    path: "/onboard",
    meta: { ...(onboardYKxWzLZMaSn_gfyUJnFv7qCyby5X9HKsYDp98_456MFOkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/pages/onboard.vue")
  },
  {
    name: "thank-you",
    path: "/thank-you",
    component: () => import("/app/pages/thank-you.vue")
  },
  {
    name: "unauthorized",
    path: "/unauthorized",
    meta: unauthorized17NYwdK_vpXoMmVXmhdTSn6CG_AM5wMHLBy01ScJbgcMeta || {},
    component: () => import("/app/pages/unauthorized.vue")
  },
  {
    name: "company",
    path: "/company",
    component: () => import("/app/pages/company/index.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    component: () => import("/app/pages/cookie-policy.vue")
  },
  {
    name: "updates",
    path: "/updates",
    component: () => import("/app/pages/updates/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: "security",
    path: "/security",
    component: () => import("/app/pages/security/index.vue")
  },
  {
    name: "updates-slug",
    path: "/updates/:slug()",
    component: () => import("/app/pages/updates/[slug].vue")
  },
  {
    name: "profile-user_id",
    path: "/profile/:user_id()",
    meta: { ...(_91user_id_93bm2q70ec2p20et3ffIlknaIdkZLGvNqMrER2nMw93WQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/profile/[user_id].vue")
  },
  {
    name: "security-extension-sbom",
    path: "/security/extension-sbom",
    component: () => import("/app/pages/security/extension-sbom.vue")
  },
  {
    name: "integrations-email-callback",
    path: "/integrations/email/callback",
    meta: callbackYf9eMQGRztYT2ybcJZ8WHwOUVqKf_9fH3KIA7mQ44E0Meta || {},
    component: () => import("/app/pages/integrations/email/callback.vue")
  },
  {
    name: "integrations-hubspot-callback",
    path: "/integrations/hubspot/callback",
    meta: callbackDusPmnNVdqJ_45XRDTZMbilOBUu97rkd1M_45ealfPCDiC8Meta || {},
    component: () => import("/app/pages/integrations/hubspot/callback.vue")
  },
  {
    name: "company-company_public_id",
    path: "/company/:company_public_id()",
    meta: { ...(indexftU2CwTklbgAtpCtZDHHzPj3QaE5Wq84XHJH3WdNkRQMeta || {}), ...{"middleware":["company","auth"]} },
    component: () => import("/app/pages/company/[company_public_id]/index.vue")
  },
  {
    name: "company-company_public_id-settings",
    path: "/company/:company_public_id()/settings",
    meta: { ...(settingsDqKUgek3SQeT_45Hr809ZCQq6IWsR6kSlxh83dOFJC6NIMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/app/pages/company/[company_public_id]/settings.vue")
  },
  {
    name: "company-company_public_id-foundation",
    path: "/company/:company_public_id()/foundation",
    meta: { ...(foundationJLT3p_yCUHcHHS_VieGJF8xRZYcJKERk9Pp9fn83OgMMeta || {}), ...{"middleware":["company","auth"]} },
    component: () => import("/app/pages/company/[company_public_id]/foundation.vue")
  },
  {
    name: "company-company_public_id-alerts",
    path: "/company/:company_public_id()/alerts",
    meta: { ...(index_bNiBJUiYXzkLRxEV6xgL9fDlJtQq3tFwpWBp_45_LT_AMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/app/pages/company/[company_public_id]/alerts/index.vue")
  },
  {
    name: "company-company_public_id-integrations",
    path: "/company/:company_public_id()/integrations",
    meta: { ...(integrationseFhaeKF4OcRFkc9QQSQXuOCd99t8ZTpvXW_C3PHvwcMMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/app/pages/company/[company_public_id]/integrations.vue")
  },
  {
    name: "company-company_public_id-ai-preferences",
    path: "/company/:company_public_id()/ai-preferences",
    meta: { ...(ai_45preferences7bprAYHe8FVBY7d1udyoOgfQatCAK6vcPpW4wjYliMYMeta || {}), ...{"middleware":["company","auth"]} },
    component: () => import("/app/pages/company/[company_public_id]/ai-preferences.vue")
  },
  {
    name: "company-company_public_id-features",
    path: "/company/:company_public_id()/features",
    meta: { ...(indexpHvT_8ZanczhfL8xDw0F_GF32u2mjYZeD9hX5nWDuUUMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/app/pages/company/[company_public_id]/features/index.vue")
  },
  {
    name: "company-company_public_id-insights",
    path: "/company/:company_public_id()/insights",
    meta: { ...(indexStUrarAaeOr8P0DAqs6Bbk0_45ZP4V8ochCDwAlZXhnyMMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/app/pages/company/[company_public_id]/insights/index.vue")
  },
  {
    name: "company-company_public_id-projects",
    path: "/company/:company_public_id()/projects",
    meta: { ...(index8s_veLAyEyKShcmg6IpB6lEF8alc5S7VqpZav4tjjt4Meta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/app/pages/company/[company_public_id]/projects/index.vue")
  },
  {
    name: "company-company_public_id-backlog-manager",
    path: "/company/:company_public_id()/backlog-manager",
    meta: { ...(backlog_45managergDNRYN7Q1PyMeYqBHy4lR4DGYSkM9CKu2SA4ryNtQFMMeta || {}), ...{"middleware":["company","auth"]} },
    component: () => import("/app/pages/company/[company_public_id]/backlog-manager.vue")
  },
  {
    name: "company-company_public_id-agent-tasks",
    path: "/company/:company_public_id()/agent-tasks",
    meta: { ...(indexMRrSYbPwzJnnj0uod9ZNXMXbmL7teDguCxR_45dCWs0SQMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/app/pages/company/[company_public_id]/agent-tasks/index.vue")
  },
  {
    name: "company-company_public_id-competitors",
    path: "/company/:company_public_id()/competitors",
    meta: { ...(indexoWuekdRHLmCaT_45ZlYj__yRquk7IaF0ZfrAUv_4509VJC4Meta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/app/pages/company/[company_public_id]/competitors/index.vue")
  },
  {
    name: "company-company_public_id-agent-tasks-task_id",
    path: "/company/:company_public_id()/agent-tasks/:task_id()",
    meta: { ...(_91task_id_935c4vvd_ddK7S5NRkBjJ8INXKH1G9IoHtmVFNFQsa9Q8Meta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/app/pages/company/[company_public_id]/agent-tasks/[task_id].vue")
  },
  {
    name: "company-company_public_id-projects-project_id",
    path: "/company/:company_public_id()/projects/:project_id()",
    meta: { ...(_91project_id_93frJzWc_450e_UqcquWof9QsMByz4l9mu6Ei3IySD4GlfAMeta || {}), ...{"middleware":["company","auth"]} },
    component: () => import("/app/pages/company/[company_public_id]/projects/[project_id].vue")
  },
  {
    name: "company-company_public_id-competitors-competitor_id",
    path: "/company/:company_public_id()/competitors/:competitor_id()",
    meta: { ...(_91competitor_id_93ePL7Epg1GwPDG5Eh52QmalJszGroO9eaqfoWN3PsG_IMeta || {}), ...{"middleware":["auth","company"]} },
    component: () => import("/app/pages/company/[company_public_id]/competitors/[competitor_id].vue")
  }
]